import Purchases from './Purchases';

export default Purchases;
